import { DropDownBox } from '@apply/components';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';
import { phoneTypes } from '../../../../../common/SharedConstants';

export const PhoneNumberBTypeField = () => {
    const value = useBrokerDetailsStore((s) => s.phoneNumberBType);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    return (
        <DropDownBox
            id='cPhoneNumberBType'
            value={value}
            onChange={(v) => updateFields({ phoneNumberBType: v })}
            label='Type'
            width={'100%'}
            dataSource={phoneTypes}
            placeholder='Select'
        />
    );
};
